<template lang="pug">
BriqPagination(
  :page="currentPage"
  :rowsPerTable="bookingsPerPage"
  :total="bookingsCount"
  @pageSelected="setPage"
  @rowsPerTableSelected="setItemsPerPage"
  )
</template>

<script>
import { mapGetters } from 'vuex'
import BriqPagination from '@/vue/components/BriqPagination.vue'

export default {
  name: 'BookingsPagination',
  components: {
    BriqPagination
  },
  computed: {
    ...mapGetters('bookings', ['currentPage', 'bookingsPerPage', 'bookingsCount'])
  },
  methods: {
    async setPage(page) {
      await this.$store.dispatch('bookings/setCurrentPage', page)
      this.$store.dispatch('bookings/fetchBookings')
    },
    async setItemsPerPage(rows) {
      await this.$store.dispatch('bookings/setRowsPerPage', rows)
      this.$store.dispatch('bookings/fetchBookings')
    }
  }
}
</script>